import { Injectable } from '@angular/core';
import { Product, Category, CategoryResponse, CategoryItems, Paging} from './product';
import { Query } from './query';
import { HttpClient, HttpHeaders, HttpParams , HttpErrorResponse, HttpResponse} from '@angular/common/http';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';
import { environment } from '../../environments/environment';

import { from } from 'rxjs/observable/from';
import { of } from 'rxjs/observable/of';
import {switchMap, mergeMap,flatMap, take, mergeAll, combineAll, map, toArray, mapTo, tap} from 'rxjs/operators';
import { Observable, Subject, BehaviorSubject } from 'rxjs';


@Injectable()
export class FavoritesService {


  private apiUrl: string  = '/api';
  private imageBase: string = '/Podium_Browser/';
  favoritesSubject: Subject<Product[]> =  new Subject<Product[]>();
  recentDownloadSubject: Subject<Product[]> =  new Subject<Product[]>();
  private _favoritesCache: Product[];


  constructor(private http: HttpClient) { 
    this.apiUrl = `${environment.serverUrl}/api`;
    this.imageBase = `${environment.imageBase}/Podium_Browser/`;
  }

  getFavoritesSubject(): Observable<Product[]>{
    return this.favoritesSubject;
  }

  getRecentDownloadSubject(): Observable<Product[]>{
    return this.recentDownloadSubject;
  }


  updateRecentDownload(): void{

    this.http.get<Paging>(`${this.apiUrl}/users/recents/`)
    .pipe(
     map((results:Paging) => results.data),
     catchError(this.handleError)
   ).subscribe((data:Product[])=> {
    this.recentDownloadSubject.next(data);
   });

  }


  updateFavorites(item?:Product, add?:boolean): void{


    if(this._favoritesCache && item){

      if(add){
        this._favoritesCache.unshift(item);

      } else {
        this._favoritesCache = this._favoritesCache.filter((itemP: Product)=> {
          return itemP.id != item.id;
        })
      }

      this.favoritesSubject.next(this._favoritesCache);

    } else {

      this.http.get<Paging>(`${this.apiUrl}/users/favorites/`)
      .pipe(
       map((results:Paging) => results.data),
       catchError(this.handleError)
     ).subscribe((data:Product[])=> {
      this.favoritesSubject.next(data);
     });
  }

 }

 favoriteToggle(item:Product, add:boolean):Observable<boolean> {


   return (add)? this.http.get<Paging>(`${this.apiUrl}/users/add_favorite/${item.id}`)
   .pipe(
    map(results => 1),
    tap(t=> this.updateFavorites(item, add)),
    catchError(this.handleError)
  ): this.http.get<Paging>(`${this.apiUrl}/users/remove_favorite/${item.id}`)
    .pipe(
     map(results => 0),
     tap(t=> this.updateFavorites(item, add)),
     catchError(this.handleError)
   );

 }


 private handleError(error: HttpErrorResponse) {
  if (error.error instanceof ErrorEvent) {
    // A client-side or network error occurred. Handle it accordingly.
    console.error('An error occurred:', error.error.message);
  } else {
    // The backend returned an unsuccessful response code.
    // The response body may contain clues as to what went wrong,
    console.error(
      `Backend returned code ${error.status}, ` +
      `body was: ${error.error}`);
  }
  // return an ErrorObservable with a user-facing error message
  return new ErrorObservable(
    'Something bad happened; please try again later.');
};



}



// WEBPACK FOOTER //
// ./src/app/products/favorites.service.ts